import {reactive, ref} from "vue";

export default {



    install(app, options) {

        const templatePermissions = {
            mobileEnabled: false,
            hasDocuments: false,
            viewAgents: false
        };

        app.config.globalProperties.$auth = {
            user: reactive({
                username: null,
                avatar: null,
                role: null
            }),
            permissions: reactive({...templatePermissions}),
            authorized: false,
            loading: ref(false),
            appKey: ref(false),
            storage: app.config.globalProperties.$storage,
            http: app.config.globalProperties.$http,
            setAuthToken(token) {
                this.storage.set('auth', {token});
            },
            getAuthToken() {
                return this.storage.get('auth', {token: null}).token;
            },
            setPermissions(permissions) {
                Object.assign(this.permissions, {...templatePermissions}, Object.fromEntries(permissions?.map(a => [a, true]) || []));
            },
            setUser(user) {
                this.user.username = user.username;
                this.user.avatar = user.avatar;
                this.user.role = user.role;},
            setAppKey(key) {
                this.appKey.value = key;
            },
            isLoading() {
                return this.loading.value
            },
            check() {
                this.loading.value = true

                console.log('sprawwdzam');

                return new Promise((resolve, reject) => {

                    if (!this.getAuthToken()) {
                        this.http.header('default', options.header.name, null);
                        return reject();
                    }

                    this.http.header('default', options.header.name, options.header.prefix + this.getAuthToken());

                    return this.http.request({url: options.uri})
                        .then((response) => {
                            this.setPermissions(response.data.permissions);
                            this.setUser(response.data.user);
                            this.setAppKey(response.data.appKey);

                            resolve()
                        })
                        .catch((e) => {

                            console.log(e);

                            reject()
                        });
                }).finally(() => {
                    this.loading.value = false;
                });

            },
            login(credentials) {
                this.setAuthToken(null);

                return this.http.request({url: options.uri, method: 'post', data: credentials})
                    .then((response) => {
                        this.setAuthToken(response.data.token);
                        // this.setUser(response.data.auth.user);


                        return response;
                    })

            },
            logout() {
                this.authorized = false;
                this.user.username = null;
                this.user.avatar = null;
                this.user.permissions = {...templatePermissions};
                this.setAuthToken(null);
            }
        };
    },

}